<template>
    <div class="replyMain">
        <el-form ref="form" :model="form" label-width="100px" class="replyform">
            <el-form-item label="终稿评分:">
                <span v-if="scoreflag">{{ finalScore}}</span>
                <span v-if="waitflag">待审批</span>
            </el-form-item>
            <el-form-item label="指导意见:">
                <p v-if="scoreflag" class="pline">{{finalOpinion}}
                </p>
                <span v-if="waitflag">待审批</span>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
export default {
    name: "final",
    data() {
        return {
            thesisRecord: {}, //提交内容
            recordData: [], //审核记录
            state: 0, //0  1  2  3未提交  未审批 驳回修改   完成
            scoreflag:false,
            waitflag:false,
            finalScore:'', //等分
            finalOpinion:''//
        }
     },
     mounted(){
        this.recordDataset();
     },
     methods: {
        recordDataset(thesisRecordId) {
            let param = {
                thesisRecordId: thesisRecordId
            }
            this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
                if (ret.code == 0) {
                    let thesisStatus = ret.data.thesisRecord.thesisStatus
                    if(thesisStatus==9 || thesisStatus==10){
                        this.scoreflag=true
                        this.waitflag=false
                        this.finalScore=ret.data.thesisRecord.finalScore
                        this.finalOpinion=ret.data.thesisRecord.finalOpinion

                    }else {
                        this.scoreflag=false
                        this.waitflag=true
                    }
                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {

            });
        }
     }
}
</script>
<style  lang="less">
.replyMain {
    padding: 15px;

    .introduce {
        color: red;
        margin-bottom: 50px;
    }

    .replyform {
        width: 868px;
        margin: 0 auto;
    }
}
.pline {
    line-height: 16px;
    position: relative;
    top: -3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/finalscore.vue